import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgSliders = function SvgSliders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B6B6B6",
    fillRule: "evenodd",
    d: "M3.692 8.611h1.231V7.39h-1.23zm1.231-2.444a1.23 1.23 0 0 1 1.23 1.222H16V8.61H6.154a1.23 1.23 0 0 1-1.23 1.222H3.691a1.23 1.23 0 0 1-1.23-1.222H0V7.39h2.462a1.23 1.23 0 0 1 1.23-1.222zm5.538 7.944h1.231V12.89h-1.23zm1.231-2.444a1.23 1.23 0 0 1 1.231 1.222H16v1.222h-3.077a1.23 1.23 0 0 1-1.23 1.222H10.46a1.23 1.23 0 0 1-1.23-1.222H0V12.89h9.23a1.23 1.23 0 0 1 1.231-1.222zm-1.23-8.556h1.23V1.89h-1.23zm2.461-1.222a1.23 1.23 0 0 0-1.23-1.222H10.46a1.23 1.23 0 0 0-1.23 1.222H0V3.11h9.23a1.23 1.23 0 0 0 1.231 1.222h1.231a1.23 1.23 0 0 0 1.231-1.222H16V1.89z",
    clipRule: "evenodd"
  })));
};

export { SvgSliders as default };
